/* ------------------------------------------------------------------
  File: BackToTop.jsx
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-03-06
------------------------------------------------------------------ */

import { useEffect, useState } from "react";
import { LuChevronUp } from "react-icons/lu";
import { IconButton } from "../../ui/Buttons";
import "./BackToTop.css";

function BackToTop() {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  
  return (
    <IconButton 
      size="md"
      icon={<LuChevronUp size={20} />}
      className={`back-to-top ${isVisible ? "show" : ""}`}
      aria-label="Back to top"
      onClick={handleScrollToTop}
    />
    
  );
}

export default BackToTop
